// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import previewImageHelper from '../../../../helpers/previewImageHelper';
import maskInput from '../../../../utils/maskInput';
import DateRangePicker from '../../../common/DateRangePicker';
import { trimCommas } from '../../../../utils/commonUtils';
import dayjs from 'dayjs';
import Axios, { AxiosResponse } from 'axios';
import type { CompanyInfo } from '../../../../models/vc/InvesteeWizard/CompanyInfo';

export default class FormView extends JQueryView {
  cloneFileElement = {};

  constructor() {
    super('.simple_form');

    this.render();
    this.renderBoardMemberArea();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  createButton(type: any, className: any) {
    const buttonText = type === 'button' ? 'キャンセル' : '';
    const buttonType = type === 'button' ? 'type="button"' : '';
    return $(
      `<${type} ${buttonType} class="${className}" data-toggle="modal" data-target="#cancelModal">${buttonText}</${type}>`,
    );
  }

  @on({ event: 'change', selector: 'input, select' })
  changeInput() {
    const cancelButton = $('.cancel-button');
    const closeButton = $('.close-button');
    const newCancelButton = this.createButton('button', 'btn btn-outline-link');
    const newCloseButton = this.createButton(
      'a',
      'close close-button c-button--remove',
    );

    cancelButton.replaceWith(newCancelButton);
    closeButton.replaceWith(newCloseButton);
  }

  @on({ event: 'click', selector: 'input[type="submit"]' })
  trimCommasFromValue() {
    $('.currency').each(function() {
      const input = $(this);
      input.val(trimCommas(input.val()));
    });
  }

  @on({ event: 'change', selector: '.choose-image' })
  changeImage(event: any) {
    const fileElement = event.currentTarget;
    if (fileElement.value === '') {
      fileElement.parentElement.append(this.cloneFileElement[fileElement.id]);
      fileElement.remove();
    } else {
      const file = fileElement.files[0];
      const maxSize = 5 * 1024 * 1024; // Maximum file size in bytes (5 MB)

      if (file.size > maxSize) {
        alert(
          maxSize / 1024 / 1024 + 'MB以上のファイルはアップロードできません',
        );
        fileElement.value = '';
      } else {
        $('.image-fields--preview')
          .last()
          .addClass('success');
        previewImageHelper($('.choose-image'), $('.upload-image'));
      }
    }
  }

  @on({ event: 'click', selector: '.choose-image' })
  keepPreviousImage(event: any) {
    const fileElement = event.currentTarget;
    if (fileElement.value !== '') {
      this.cloneFileElement[fileElement.id] = fileElement.cloneNode(true);
    }
  }

  @on({ event: 'click', selector: '.remove-button' })
  onClickRemoveFields(event: any) {
    const _destroy = $(event.target)
      .parents('fieldset')
      .find('._destroy');
    _destroy.val('1');
    _destroy.closest('fieldset').hide();
    event.preventDefault();
    this.renderBoardMemberArea();
  }

  @on({ event: 'click', selector: '.add-button' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $('.add-member-wrapper').append(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderBoardMemberArea();
    this.render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    target.toggleClass('form-control-active', target.val().length !== 0);
    target.removeClass('is-invalid');
    removeInvalidFeedback(target);
    target.removeClass('focus');
  }

  renderBoardMemberArea() {
    const maxBoardMemberCount = 20;
    if ($('fieldset:visible').length >= maxBoardMemberCount) {
      $('.add-button').hide();
    } else {
      $('.add-button').show();
    }
  }

  @on({ event: 'input', selector: '#company_investee_name' })
  onCompanyInputControl(event: any) {
    const keyword = event.target.value;
    const maxLength = 42;
    const displayedName = (companyName: string) =>
      companyName.length > maxLength
        ? companyName.substring(0, maxLength - 1) + '...'
        : companyName;
    const dropdown = $('#company-dropdown');
    Axios.get('/api/v1/my/vc/investee_wizard/company_info', {
      params: { keyword },
    }).then(function(response) {
      dropdown.empty();
      if (response.data.length > 0) {
        response.data.forEach(function(company) {
          dropdown.append(`
            <span class="dropdown-item" data-value="${
              company[0]
            }">${displayedName(company[1])}</span>
          `);
        });
        $('.dropdown-menu').addClass('show');
      } else {
        $('.dropdown-menu').removeClass('show');
      }
    });
  }

  @on({ event: 'click', selector: '.dropdown-item' })
  onClickDropdownItem(event: any) {
    const id = $(event.target).data('value');
    Axios.get(`/api/v1/my/vc/investee_wizard/company_info/${id}`).then(function(
      response: AxiosResponse<CompanyInfo>,
    ) {
      const company: CompanyInfo = response.data;
      $('#company_investee_name').val(company.name);
      $('#company_investee_name_kana').val(company.kana_name);
      $('#company_investee_board_members_attributes_0_name').val(
        company.representative,
      );
      $('#company_investee_website').val(company.website);
      $('#company_investee_zip_code').val(company.zip_code);
      $('#company_investee_zip_code').toggleClass(
        'form-control-active',
        Boolean(company.zip_code),
      );
      $('#company_investee_prefecture').val(company.prefecture);
      $('#company_investee_prefecture').toggleClass(
        'form-control-active',
        Boolean(company.prefecture),
      );
      $('#company_investee_city').val(company.city);
      $('#company_investee_city').toggleClass(
        'form-control-active',
        Boolean(company.city),
      );
      $('#company_investee_address').val(company.address);
      $('#company_investee_address').toggleClass(
        'form-control-active',
        Boolean(company.address),
      );
      $('#company_investee_closing_month').val(company.closing_month);
      $('#company_investee_establish_on').val(
        company.establish_at ? company.establish_at.replace(/-/g, '/') : '',
      );
    });
    $('.dropdown-menu').removeClass('show');
  }

  @on({ event: 'click' })
  hideDropdownMenu(event: any) {
    const target = $(event.target);
    if (!target.closest('#company_investee_name').length) {
      $('.dropdown-menu').removeClass('show');
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
    maskInput();
  }
}
